/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SystemFiles/view.blocks to change it.
import FilesTree from './FilesTree/index'
import Preview from './Preview/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SystemFiles({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions/Upload/Content/Documents/Content/SystemFiles"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="SystemFiles.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<FilesTree
  viewPath={`${viewPath}/FilesTree`}
/>
<Preview
  viewPath={`${viewPath}/Preview`}
/>
</div>
{children}
</React.Fragment>)
}